module.exports = __webpack_public_path__ + "img/orange_057.3c7d8ff0.png";